var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 26,
    viewBox: "0 0 21 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.95807 25.125H16.4031C18.8291 25.125 20.0361 23.8945 20.0361 21.457V10.8165H11.5516C10.0516 10.8165 9.34857 10.1015 9.34857 8.6015V0H3.95807C1.54407 0 0.325073 1.242 0.325073 3.68V21.457C0.325073 23.906 1.54407 25.125 3.95807 25.125ZM11.5871 9.211H19.9071C19.8251 8.7305 19.4851 8.2615 18.9346 7.6875L12.4656 1.1135C11.9266 0.551 11.4346 0.211 10.9421 0.1285V8.5785C10.9421 9 11.1651 9.211 11.5871 9.211Z",
    fill: "#FF9595"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIconRed);
export default __webpack_public_path__ + "static/media/document-icon-red.a524c727382b56a55b2ef64116b73ab7.svg";
export { ForwardRef as ReactComponent };